import classNames from 'classnames';
import { IconCaretDownFilled, IconCaretRightFilled } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import PeriodCellValue from 'views/ProFormaTable/components/ProForma/ProFormaDevelopment/DevelopmentUsesTable/PeriodCellValue/PeriodCellValue';
import { IExtractedUse } from 'types/db/ExtractedProForma';
import { IFormattedCashFlowPeriod } from 'views/ProFormaTable/types';
import { PERIOD_CELL_CLASS_NAME } from '../../constants';
import { formatAmount, periodValues, sumPeriodValues, sumValues, toNumber } from '../../helpers';

export interface UsesBucketRowsProps {
    use: IExtractedUse;
    isExpanded: boolean;
    onToggle: () => void;
    periodColumns: IFormattedCashFlowPeriod[];
}

const UsesBucketRows = ({
    use, periodColumns, isExpanded, onToggle,
}: UsesBucketRowsProps) => {
    const hasBudgetLines = use.budgetLines.length > 0;
    const bucketTotal = hasBudgetLines ? sumValues(use.budgetLines.map(line => toNumber(line.total))) : null;
    const bucketPeriodTotals = sumPeriodValues(use.budgetLines.map(line => periodValues(line.periods)));

    return (
        <>
            <tr className="NSTable__tbody__tr NSTable__tbody__tr--level-1">
                <td className="NSTable__tbody__tr__td NSTable__tbody__tr__td--right-border text-dark">
                    <button
                        type="button"
                        className="btn btn-link p-0 text-dark text-left"
                        aria-expanded={hasBudgetLines ? isExpanded : undefined}
                        disabled={!hasBudgetLines}
                        onClick={onToggle}
                    >
                        {hasBudgetLines && (
                            <NSIcon className="icon mr-1" icon={isExpanded ? IconCaretDownFilled : IconCaretRightFilled} />
                        )}
                        <span className={classNames({ 'ml-3': !hasBudgetLines })}>{use.name}</span>
                    </button>
                </td>
                <td className="NSTable__tbody__tr__td NSTable__tbody__tr__td--right-border text-dark text-right text-nowrap pr-2">
                    {formatAmount(bucketTotal)}
                </td>
                {periodColumns.map(column => (
                    <PeriodCellValue
                        key={column.value}
                        period={column}
                        value={formatAmount(bucketPeriodTotals.get(column.period) ?? null)}
                        cellClassName={PERIOD_CELL_CLASS_NAME}
                    />
                ))}
            </tr>
            {isExpanded && use.budgetLines.map((line, index) => {
                const linePeriodValues = periodValues(line.periods);
                return (
                    <tr key={`${line.name}-${index}`} className="NSTable__tbody__tr NSTable__tbody__tr--level-2">
                        <td className="NSTable__tbody__tr__td NSTable__tbody__tr__td--right-border text-dark pl-4">{line.name}</td>
                        <td className="NSTable__tbody__tr__td NSTable__tbody__tr__td--right-border text-dark text-right text-nowrap pr-2">
                            {formatAmount(toNumber(line.total))}
                        </td>
                        {periodColumns.map(column => (
                            <PeriodCellValue
                                key={column.value}
                                period={column}
                                value={formatAmount(linePeriodValues.get(column.period) ?? null)}
                                cellClassName={PERIOD_CELL_CLASS_NAME}
                            />
                        ))}
                    </tr>
                );
            })}
        </>
    );
};

export default UsesBucketRows;
